<!-- Dialog header -->
<div class="modal add-on">
  <div class="modal__header">
    <div class="grid-row grid-row--aic">

      <!-- Title -->
      <div class="grid-col">
        <h3>Add additional service</h3>
      </div>

      <!-- Close button -->
      <div class="grid-col grid-col--auto">
        <button (click)="close()" type="button" class="modal__close">
          <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Dialog content -->
  <div class="modal__cont">
    <form [formGroup]="form">
      <p class="mb--150 content-header">If your invoice indicates optional add-ons or you have an invoice not listed,
        you can add that here.</p>

      <!-- Account selection -->
      <ng-container *ngIf="accounts$ | async as accounts">
        <ng-container *ngIf="accounts.length > 1">
          <label class="mb--050">Account</label>
          <select class="form-select mb--050" [formControl]="accountControl"
                  [ngClass]="{ 'form-input--invalid': accountControl.invalid && (accountControl.dirty || accountControl.touched) }">
            <option [ngValue]="null" hidden>Select</option> <!-- Placeholder (hidden in dropdown) -->
            <option *ngFor="let account of accounts" [ngValue]="account">{{ account.name}}</option>
          </select>
          <p class="account-hint mb--150">Which account is this for?</p>
        </ng-container>
      </ng-container>

      <!-- Add-on type selection -->
      <ng-container *ngIf="data.addOnOptions.length > 1">
        <label class="mb--050">Type of add-on</label>
        <mat-radio-group
          [formControl]="typeControl"
          [ngClass]="{ 'form-input--invalid': typeControl.invalid && (typeControl.dirty || typeControl.touched) }"
        >
          <mat-radio-button class="mb--050" *ngFor="let option of data.addOnOptions" [value]="option">
            {{ option.input.label }}
          </mat-radio-button>
        </mat-radio-group>
      </ng-container>

      <!-- Add-on notes -->
      <label class="mb--050">{{ typeControl.value.input.label }}</label>
      <textarea *ngIf="typeControl.value.input.type === AddOnInputType.TEXT_BOX; else input" [formControl]="notesControl"
                class="form-input mb--050" maxlength="140" data-cy="addon-on-notes"
                [ngClass]="{ 'form-input--invalid' : notesControl.invalid && (notesControl.dirty || notesControl.touched) }"></textarea>
      <ng-template #input><input class="form-input mb--050" [formControl]="notesControl"
                                 [ngClass]="{ 'form-input--invalid': notesControl.invalid && (notesControl.dirty || notesControl.touched) }"/>
      </ng-template>
      <div class="notes-hint markdown" [innerHTML]="typeControl.value.input.hint | marked"></div>

      <!-- Payment amount -->
      <label class="mt--150 mb--050">Payment Amount</label>
      <input maxlength="140" aria-labelledby="payment-amount-label" data-cy="payment-amount"
             [formControl]="paymentAmountControl"
             class="form-input form-input--top form-input--right form-input--amount payment-amount"
             currencyMask [options]="{ prefix: '$', align: 'right', allowNegative: 'false'}"
             [ngClass]="{ 'form-input--invalid': paymentAmountControl.invalid && (paymentAmountControl.dirty || paymentAmountControl.touched) }">
    </form>

    <!-- Dialog footer (action buttons) -->
    <div class="mt--125 grid-row grid-row--jcb">
      <div class="grid-col grid-col--auto">
        <button
          andButton
          (click)="close()"
          type="button"
        >
          Cancel
        </button>
      </div>
      <div class="grid-col grid-col--auto">
        <button
          andButton
          color="primary"
          (click)="submit()"
          data-cy="add-to-payment-button"
        >
          Add to Payment
        </button>
      </div>
    </div>
  </div>
</div>
